import '../../App.css'
import React, { useContext, useEffect, useState } from 'react'
import Aside from '../../component/aside'
import { useNavigate } from 'react-router-dom'
import Navbar from '../../component/navbar'
import Loading from '../../component/loading'
import RequestQueue from '../../api/requestQueue'
import { toast } from 'react-toastify'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'
import { AppContextMenu } from '../../App'
import { FormJsonToShamsiTime } from '../../component/FormJsonToShamsiTime'
import { FormJsonToShamsiDay } from '../../component/FormJsonToShamsiDay'
import Pagination from 'rc-pagination'

function Users() {
    const { updateValue } = useContext(AppContextMenu)
    useEffect(() => {
        updateValue('users')
    }, [])
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        if (!JSON.parse(localStorage.getItem('authResult'))) {
            navigate('/login')
        }
    }, [])
    const [dataGet, setDataGet] = useState([])
    let navigate = useNavigate()

    const [currentPage, setCurrentPage] = useState(1)
    const pageSize = 10
    const [total, setTotal] = useState(10)
    const onChange = (page) => {
        setCurrentPage(page)
        // اینجا می‌توانید داده‌های مربوط به صفحه جدید را بارگذاری کنید
    }

    useEffect(() => {
        getData()
    }, [currentPage])

    const getData = async () => {
        setLoading(true)
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/user?page=${currentPage}&limit=${pageSize}`,
            },
            resolve: (res) => {
                setDataGet(res.data.data)
                setTotal(res.data.totalUsers)
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const handlerDelete = async (id) => {
        await RequestQueue.sendRequest({
            config: {
                method: 'delete',
                url: `/user/${id}`,
            },
            resolve: (res) => {
                getData()
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const renderPageItem = (current, type, originalElement) => {
        if (type === 'prev') {
            return (
                <button className="px-4 py-2 hover:text-indigo-800">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="size-4"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5"
                        />
                    </svg>
                </button>
            )
        }
        if (type === 'next') {
            return (
                <button className="px-4 py-2  hover:text-indigo-800">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="size-4"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5"
                        />
                    </svg>
                </button>
            )
        }
        if (type === 'page') {
            return (
                <button
                    className={`px-2.5 m-1 py-0.5  rounded-md ${current === currentPage ? 'bg-indigo-700 text-white' : 'bg-white border border-gray-300 '}`}
                >
                    {current}
                </button>
            )
        }
        if (type === 'jump-prev' || type === 'jump-next') {
            return (
                <button className="bg-white border border-gray-300 rounded-md px-2.5 m-1 py-0.5  ">
                    ...
                </button>
            )
        }
        return originalElement
    }

    return (
        <>
            {loading ? <Loading /> : null}
            <div className="container">
                <Aside />
                <main className="main-content">
                    <Navbar />
                    <div className="box transaction-box w-full">
                        <div className="w-full px-4 py-8">
                            <div className="bg-white w-full rounded-xl shadow-sm  border border-gray-100">
                                {/* Header - Fixed Desktop Style */}
                                <div className="px-6 py-5 border-b rounded-xl border-gray-200 flex maxLg:flex-col justify-between items-center bg-gradient-to-r from-purple-100 to-indigo-500">
                                    <h2 className="text-2xl font-semibold text-white">
                                        لیست کاربران
                                    </h2>
                                    <button
                                        className="bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 transition-all shadow-md hover:shadow-lg text-white px-5 py-2.5 rounded-lg duration-300 transform hover:-translate-y-0.5 flex items-center gap-2"
                                        onClick={() => navigate('/userAdd')}
                                    >
                                        <FontAwesomeIcon
                                            icon={faPlus}
                                            className="text-white"
                                        />
                                        <span>افزودن</span>
                                    </button>
                                </div>

                                {/* Table Container */}
                                <div className="overflow-x-auto w-full">
                                    <div
                                        className="w-full"
                                        style={{ minWidth: '100%' }}
                                    >
                                        <table className="w-full divide-y divide-gray-200">
                                            {/* Table Header */}
                                            <thead className="bg-gray-50">
                                                <tr>
                                                    {RequestQueue.getAuthResult()
                                                        ?.user?.role?.name ===
                                                        'superAdmin' && (
                                                        <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                            سازمان
                                                        </th>
                                                    )}

                                                    <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                        نام
                                                    </th>
                                                    <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                        شماره همراه
                                                    </th>
                                                    <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                        نقش
                                                    </th>
                                                    <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                        شیفت
                                                    </th>
                                                    <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                        بخش کاری / جایگاه شغلی
                                                    </th>
                                                    <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                        تاریخ ایجاد
                                                    </th>
                                                    <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                        ویرایش
                                                    </th>
                                                    <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                        حذف
                                                    </th>
                                                </tr>
                                            </thead>

                                            {/* Table Body */}
                                            <tbody className="bg-white divide-y divide-gray-100">
                                                {dataGet.map((d) => (
                                                    <tr
                                                        key={d.id}
                                                        className="group transition-all duration-300 hover:bg-gradient-to-r hover:to-indigo-100 hover:via-white hover:from-purple-100"
                                                    >
                                                        {RequestQueue.getAuthResult()
                                                            ?.user?.role
                                                            ?.name ===
                                                            'superAdmin' && (
                                                            <td className="px-6 py-4 whitespace-nowrap text-center">
                                                                <div className="text-sm text-gray-900">
                                                                    {
                                                                        d
                                                                            .organization_data
                                                                            ?.name
                                                                    }
                                                                </div>
                                                            </td>
                                                        )}

                                                        <td className="px-6 py-4 whitespace-nowrap text-center">
                                                            <div className="text-sm text-gray-900">
                                                                {d.full_name}
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-center">
                                                            <div className="text-sm text-gray-900">
                                                                {d.phone_number}
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-center">
                                                            <div className="text-sm text-gray-900">
                                                                {
                                                                    d.role
                                                                        ?.nick_name
                                                                }
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-center">
                                                            <div className="text-sm text-gray-900">
                                                                {d.shift?.name}
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 text-center">
                                                            <div className="text-sm text-gray-900 space-y-2">
                                                                {d.userDepartmentPosition?.map(
                                                                    (
                                                                        item,
                                                                        index
                                                                    ) => (
                                                                        <div
                                                                            key={
                                                                                index
                                                                            }
                                                                            className="flex justify-center items-center"
                                                                        >
                                                                            <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-md text-xs">
                                                                                {
                                                                                    item
                                                                                        .department
                                                                                        .name
                                                                                }
                                                                            </span>
                                                                            <span className="mx-2">
                                                                                ←
                                                                            </span>
                                                                            <span className="bg-green-100 text-green-800 px-2 py-1 rounded-md text-xs">
                                                                                {
                                                                                    item
                                                                                        .position
                                                                                        .name
                                                                                }
                                                                            </span>
                                                                        </div>
                                                                    )
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-center">
                                                            <div className="text-sm text-gray-900">
                                                                {FormJsonToShamsiDay(
                                                                    d.created_at
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                                                            <div className="flex justify-center">
                                                                <button
                                                                    className="text-indigo-600 hover:text-indigo-800 bg-indigo-50 hover:bg-indigo-100 px-3 py-1.5 rounded-lg transition-colors duration-200"
                                                                    onClick={() =>
                                                                        navigate(
                                                                            `/userEdit/${d.id}`
                                                                        )
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faEdit
                                                                        }
                                                                        className="ml-2"
                                                                    />
                                                                    ویرایش
                                                                </button>
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                                                            <div className="flex justify-center space-x-3 space-x-reverse">
                                                                <button
                                                                    className="text-red-600 hover:text-red-800 bg-red-50 hover:bg-red-100 px-3 py-1.5 rounded-lg transition-colors duration-200"
                                                                    onClick={() =>
                                                                        handlerDelete(
                                                                            d.id
                                                                        )
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faTrash
                                                                        }
                                                                        className="ml-2"
                                                                    />
                                                                    حذف
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <Pagination
                                    current={currentPage}
                                    pageSize={pageSize}
                                    total={total}
                                    showLessItems={true}
                                    onChange={onChange}
                                    className="flex justify-center items-center"
                                    itemRender={renderPageItem}
                                />
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}

export default Users
